import Add from "@mui/icons-material/Add";
import Block from "@mui/icons-material/Block";
import { TableCell, TableHead } from "@mui/material";
import React from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import aderantTheme from "../../../Theme/AderantTheme";
import ColumnResizer from "../ColumnResizer";
import HeaderCell from "../HeaderCell";
export default function DataGridHeader(props) {
    const { allowMoveColumns, bodyRef, fixedColumnCount, fixedHeadersElement, headerRef, state, headerGroups, setColumnOrder, visibleColumns } = props;
    return (React.createElement(TableHead, { component: "div", className: "data-grid-header", role: "rowheader", style: {
            display: "flex",
            backgroundColor: aderantTheme.palette.background.header,
            color: aderantTheme.palette.text.white,
            top: 0,
            position: "sticky",
            zIndex: 4,
            minHeight: 40,
            overflow: "auto hidden",
            paddingLeft: fixedHeadersElement?.getBoundingClientRect().width
        }, ref: headerRef, onScroll: () => {
            if (headerRef?.current && bodyRef?.current) {
                headerRef.current.scrollLeft = bodyRef.current.scrollLeft;
            }
        } }, getDataGridHeader(allowMoveColumns, state.headerWidths, fixedColumnCount, headerGroups, setColumnOrder, visibleColumns)));
}
const getHeaderStyle = ({ isDragging, isDropAnimating }, draggableStyle, align) => ({
    userSelect: "none",
    alignItems: "center",
    width: "100%",
    justifyContent: align == "left" ? "flex-start" : align == "right" ? "flex-end" : align,
    display: "flex",
    ...(isDragging
        ? {
            //Style applied when column is being dragged
            ...draggableStyle,
            color: aderantTheme.palette.text.black,
            border: `1px solid ${aderantTheme.palette.border.main}`,
            background: aderantTheme.palette.background.white,
            fontSize: "0.9em",
            height: "2em",
            width: "auto",
            padding: 5,
            position: "static"
        }
        : {}),
    ...(isDropAnimating && { transitionDuration: "0.001s" })
});
/**
 * A function that renders the column headers of the DataGrid.
 */
export const getDataGridHeader = (allowMoveColumns, columnWidths, fixedColumnCount, headerGroups, setColumnOrder, visibleColumns) => {
    return headerGroups.map((headerGroup) => getColumnHeader(allowMoveColumns, columnWidths, fixedColumnCount, headerGroup, setColumnOrder, visibleColumns));
};
const getColumnHeader = (allowMoveColumns, columnWidths, fixedColumnCount, headerGroup, setColumnOrder, visibleColumns) => {
    return (React.createElement(DragDropContext, { key: headerGroup.getHeaderGroupProps().key, onDragEnd: (dragUpdateObj) => {
            //When done dragging, change column order in react table.
            const colOrder = visibleColumns.map((col) => col.id);
            const startIndex = dragUpdateObj.source.index + fixedColumnCount; // offset indexes by fixedColumnCount
            const destIndex = dragUpdateObj.destination && dragUpdateObj.destination.index + fixedColumnCount;
            if (typeof startIndex === "number" && typeof destIndex === "number") {
                //Remove column from original index
                colOrder.splice(startIndex, 1);
                //Insert column being dragged into the destination index
                colOrder.splice(destIndex, 0, dragUpdateObj.draggableId);
                setColumnOrder(colOrder);
            }
        } },
        React.createElement(Droppable, { droppableId: "droppable", direction: "horizontal" }, (droppableProvided) => (React.createElement("div", { ...headerGroup.getHeaderGroupProps({ style: { position: "relative" } }), ref: (element) => void droppableProvided.innerRef(element) },
            headerGroup.headers.slice(fixedColumnCount).map((column, index) => {
                return (
                //Map each column as a draggable element
                React.createElement(Draggable, { key: column.id, draggableId: column.id, index: index, isDragDisabled: !allowMoveColumns }, 
                //provided: contains props for the draggable object
                //snapshot: contains the state of the draggable object
                (provided, snapshot) => {
                    return (React.createElement("div", { className: "data-grid-column-header", id: `header-${column.id}`, style: {
                            width: columnWidths[column.id] ?? column.pxWidth ?? column.width,
                            maxWidth: column.maxWidth,
                            minWidth: column.minWidth,
                            display: "flex",
                            flexShrink: 0,
                            ...(column.flexGrow && { flexGrow: column.flexGrow }),
                            ...(!(column.flexGrow || column.pxWidth) && { flexGrow: 1 })
                        }, role: "columnheader" },
                        React.createElement(TableCell, { className: "data-grid-column-header-cell", component: "div", ...column.getHeaderProps(column.getSortByToggleProps()), ...provided.draggableProps, ...provided.dragHandleProps, ref: (element) => void provided.innerRef(element), style: {
                                ...getHeaderStyle(snapshot, provided.draggableProps.style, column.align)
                            }, role: "cell" },
                            snapshot.draggingOver ? (React.createElement(Add, { fontSize: "small", style: { display: snapshot.isDragging ? "" : "none" } })) : (React.createElement(Block, { fontSize: "small", style: { display: snapshot.isDragging ? "" : "none" } })),
                            React.createElement(HeaderCell, { ...column })),
                        React.createElement(ColumnResizer, { column: column })));
                }));
            }),
            React.createElement("span", { style: { display: "none" } }, droppableProvided.placeholder))))));
};
